export function formatSourceUrlCitation(input: {
  title: string;
  url: string;
  retrievedAt?: string;
}): string {
  const title = input.title.trim() || "Untitled source";
  const url = input.url.trim();
  const retrieved = formatReferenceDate(input.retrievedAt ?? new Date().toISOString());

  if (!url) {
    return `${title}. (n.d.).`;
  }

  return `${title}. (n.d.). Retrieved ${retrieved}, from ${url}`;
}

function formatReferenceDate(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "n.d.";
  }

  return parsed.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
